import axios from "axios";
import { config } from "@/config";

export type CreatePerkPointProgramPayload = {
  name: string;
  slug: string;
  currency: string;
  time_zone: string;
  data_region: string;
  point_value: number;
  point_name: string;
  program_name: string;
  program_code: string;
  domain: string;
  cost_per_point: number;
  loyalty_currency_id: string;
  invoice_frequency_in_days: number;
  percentage_of_cashback_to_be_accrued: number;
  tax_id: string;
  address: string;
  website_url: string;
  country: string;
  city: string;
  offer_denomination: number;
  txn_commission_pct_charged_to_prg: number;
  industry?: string;
  program_owner?: string;
  brand_primary_color?: string;
  client_legal_name?: string;
  billing_contact_name?: string;
  billing_contact_email?: string;
  member_terms_url?: string;
  member_terms_version?: string;
  privacy_policy_url?: string;
  privacy_policy_version?: string;
  program_logo_uri?: string;
  supported_languages?: string[];
  points_rounding?: string;
  points_hold_days?: number | null;
  cancellation_period_days?: number | null;
  points_expiry_mode?: string;
  points_expiry_months?: number | null;
  negative_balance_policy?: string;
  bonus_combine_mode?: string;
  enrolment_mode?: string;
  member_id_type?: string;
  personal_data_collected?: string[];
  consent_channels?: string[];
  data_retention_months?: number;
  erasure_policy?: string;
  enabled_event_types?: string[];
  custom_attributes?: string[];
  webhook_url?: string;
  messaging_enabled?: boolean;
  messaging_whatsapp_number?: string;
  messaging_sms_sender_id?: string;
  messaging_from_email?: string;
  quiet_hours_start?: string;
  quiet_hours_end?: string;
  message_frequency_cap?: number;
  offer_approval_threshold?: number;
  adjustment_approval_threshold?: number;
  support_agent_adjustment_cap?: number;
  economy_effective_date?: string | null;
  economy_notice_acknowledged?: boolean;
};

const perkPointClient = axios.create({
  baseURL: config.PERKPOINT_API_URL || "http://localhost:3000",
});

export class PerkPointProgramApi {
  static createProgram(payload: CreatePerkPointProgramPayload) {
    const token = config.PERKPOINT_ADMIN_TOKEN || "dev-admin-token";
    return perkPointClient.post("/admin/programs", payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
  }
}
